$(document).on("click", "#generate_public", function (e) {
  e.preventDefault();
  e.stopPropagation();

  let r = confirm(
    "Are you sure you want to publish this content to live?"
  );
  if (r) {
    // ok
  } else {
    // they cancelled, don't do it.
    return
  }

  $("#busy_modal").modal({ backdrop: "static", keyboard: false });
  // $('#busy_modal').modal('toggle')

  // 400 * 2000... ~ 10min
  let max_counter = 400;

  // <li><%=link_to 'Generate Previews',  "/pages/generate_previews", remote:true, data: {disable_with: "<i class='fa fa-spinner fa-spin'></i> Building Preview..."}  %> </li>
  $.ajax({
    url: "/pages/generate_public_release",
    type: "GET",
    timeout: 1000,
    success: function (response) {
      console.log(response);
    },
    error: function (xmlhttprequest, textstatus, message) {
      console.log(textstatus);
    }
  });

  setTimeout(check_preview_done, 3000);

  function check_preview_done() {
    max_counter -= 1;
    if (max_counter < 0) {
      $("#busy_modal").modal("toggle");
      alert("Unable to create preview right now");
      return;
    }

    $.get("/pages/check_public_release", function (data) {
      console.log(data);
      if (data.azure == 1) {
        html_page = document.getElementById("public-link");
        html_page.innerHTML = data.html;
        $("#busy_modal").modal("hide");
      } else {
        setTimeout(check_preview_done, 2000);
      }
    });
  }
  return false;
});
$(document).on('click', '#generate_public_tree', function (e) {
  e.preventDefault()
  e.stopPropagation()

  let r = confirm('Are you sure you want to publish this content to live?')
  if (r) {
    // ok
  } else {
    // they cancelled, don't do it.
    return
  }

  $('#busy_modal').modal({ backdrop: 'static', keyboard: false })
  // $('#busy_modal').modal('toggle')

  // 400 * 2000... ~ 10min
  let max_counter = 400

  let page_id = $(this).data('pageid')

  // <li><%=link_to 'Generate Previews',  "/pages/generate_previews", remote:true, data: {disable_with: "<i class='fa fa-spinner fa-spin'></i> Building Preview..."}  %> </li>
  $.ajax({
    url: '/pages/generate_public_release_tree',
    data: { page: { export_page_id: page_id } },
    type: 'POST',
    timeout: 1000,
    success: function (response) {
      console.log(response)
    },
    error: function (xmlhttprequest, textstatus, message) {
      console.log(textstatus)
    },
  })

  setTimeout(check_preview_done, 3000)

  function check_preview_done() {
    max_counter -= 1
    if (max_counter < 0) {
      $('#busy_modal').modal('toggle')
      alert('Unable to create preview right now')
      return
    }

    $.get('/pages/check_public_release', function (data) {
      console.log(data)
      if (data.azure == 1) {
        // html_page = document.getElementById('public-link')
        // html_page.innerHTML = data.html
        $('#busy_modal').modal('hide')
      } else {
        setTimeout(check_preview_done, 2000)
      }
    })
  }
  return false
})